import { render, staticRenderFns } from "./EditCard.vue?vue&type=template&id=fccfe474"
import script from "./EditCard.vue?vue&type=script&lang=js"
export * from "./EditCard.vue?vue&type=script&lang=js"
import style0 from "./EditCard.vue?vue&type=style&index=0&id=fccfe474&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports